import BaseWrapper from "../../components/ui/BaseWrapper";
import BaseTextField from "../../components/ui/BaseTextField";
import BaseButton from "../../components/ui/BaseButton";
import { useDispatch } from "react-redux";
import { setWorkforceFilters } from "../../store/filters/workforceFiltersSlice";
import { useRef, useState } from "react";
import { debounce } from "../../utils/helpers";
import AddEditTalentPoolModal from "./components/AddEditTalentPoolModal";
import CompleteProfileModal from "../WorkJobDetails/CompleteProfileModal";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import useAuth from "../../hooks/useAuth";
import { ModuleType } from "../../utils/enum";

const TalentPoolsListingHeader = ({
  refetchTalentPool,
  search,
  setSearch,
  setDebouncedSearch,
}) => {
  const [isAddEditTalentPoolModalOpen, setIsAddEditTalentPoolModalOpen] =
    useState(false);
  const { userData } = useCurrentUser();
  const [isProfileCompleted, setIsProfileCompleted] = useState(false);
  const { authRole, getPermissionForModule } = useAuth();
  const { hasWriteAccess: hasTalentPoolWriteAccess } = getPermissionForModule(
    ModuleType.WORK_FORCE_TALENT_POOL
  );

  const dispatch = useDispatch();

  const debouncedSearchRef = useRef(
    debounce((value) => {
      setDebouncedSearch(value);
      dispatch(
        setWorkforceFilters({
          filterName: "search",
          data: value,
        })
      );
    }, 500)
  );

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    debouncedSearchRef.current(e.target.value);
  };

  return (
    <>
      <div className="border-b border-zinc-300 bg-white">
        <BaseWrapper>
          <div className="py-[7px] flex justify-between">
            <h3 className="font-light">Talent Pools</h3>
            {hasTalentPoolWriteAccess && (
              <div>
                <BaseButton
                  color="primary"
                  className="py-[4px] px-[28px]"
                  onClick={() => {
                    if (userData?.status === "APPROVED") {
                      setIsProfileCompleted(true);
                    }
                    setIsAddEditTalentPoolModalOpen(true);
                  }}
                >
                  Create New Talent Pool
                </BaseButton>
              </div>
            )}
          </div>
        </BaseWrapper>
      </div>
      <BaseWrapper>
        <div className="bg-white rounded-lg px-5 py-2 shadow-md mt-2">
          <div className="flex justify-between items-center w-full">
            <div className="flex items-center border-r-[1px] border-[#8C8C8C] pr-5">
              {/* <i className="fa-solid fa-circle-plus text-secondary text-[22px]"></i>
              <p className="text-secondary ml-2 ">Add Filter</p> */}
            </div>
            <div className=" w-[28%]">
              <BaseTextField
                placeholder={`Search by name or created by`}
                value={search}
                onChange={(e) => handleSearchChange(e)}
                startAdornment={
                  <i className="fa-light fa-magnifying-glass text-lg"></i>
                }
              />
            </div>
          </div>
        </div>
      </BaseWrapper>

      {isAddEditTalentPoolModalOpen && isProfileCompleted && (
        <AddEditTalentPoolModal
          setIsAddEditTalentPoolModalOpen={setIsAddEditTalentPoolModalOpen}
          isAddEditTalentPoolModalOpen={isAddEditTalentPoolModalOpen}
          refetchTalentPool={refetchTalentPool}
        />
      )}

      {isProfileCompleted === false && (
        <CompleteProfileModal
          isProfileCompleted={isProfileCompleted}
          setIsProfileCompleted={setIsProfileCompleted}
          status={userData?.status}
          authRole={authRole}
        />
      )}
    </>
  );
};

export default TalentPoolsListingHeader;
